/**
 * Functional‑Design toast messages
 * --------------------------------
 */
export const FDToast = {
  /* File download / upload */
  DOWNLOAD_STARTED: 'Download started',
  DOWNLOAD_DOCX_ERROR: 'Error downloading DOCX',
  UPLOAD_ERROR: 'Error uploading file',

  /* Document generation */
  PREPARING_DOCUMENT: 'Preparaing data for Document', // ← spelling kept to match existing copy
  PDF_GENERATED: 'PDF generated',
  PDF_GENERATION_ERROR: 'Error generating PDF',

  /* Viewer / save guards */
  FILE_LOAD_ERROR: 'Failed to load file',
  NO_DOC_TO_SAVE: 'No document to save. Please generate a document first.',
  NO_DOC_TO_VIEW: 'No document to view. Please generate a document first.',
} as const;

/** Union of all valid keys for type‑safe helpers */
export type FDToastKey = keyof typeof FDToast;
